import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const EMPRESA_PADRAO  = { nome: 'Vuli Group', slogan: 'Inteligência que move resultados.', email: 'contato@vuligroup.com', whatsapp: '(85) 99999-0000' };
const NOTIF_PADRAO    = { novoLead: true, followup: true, noshow: true, meta: false };

export default function Configuracoes() {
  const [empresa, setEmpresa] = useState(EMPRESA_PADRAO);
  const [notif,   setNotif]   = useState(NOTIF_PADRAO);
  const [carregando, setCarregando] = useState(true);
  const [salvando,   setSalvando]   = useState(false);
  const [salvo,      setSalvo]      = useState(false);
  const [erro,       setErro]       = useState('');

  useEffect(() => { carregarConfigs(); }, []);

  async function carregarConfigs() {
    setCarregando(true);
    const { data } = await supabase.from('configuracoes').select('*');
    if (data) {
      const emp  = data.find(c => c.chave === 'empresa');
      const ntf  = data.find(c => c.chave === 'notificacoes');
      if (emp?.valor)  setEmpresa(emp.valor);
      if (ntf?.valor)  setNotif(ntf.valor);
    }
    setCarregando(false);
  }

  async function salvar() {
    setSalvando(true);
    setErro('');
    const ops = [
      supabase.from('configuracoes').upsert({ chave: 'empresa',       valor: empresa },       { onConflict: 'chave' }),
      supabase.from('configuracoes').upsert({ chave: 'notificacoes',  valor: notif   },       { onConflict: 'chave' }),
    ];
    const results = await Promise.all(ops);
    const erros = results.filter(r => r.error);
    if (erros.length > 0) {
      setErro('Erro ao salvar. Verifique se a tabela "configuracoes" existe no Supabase.');
    } else {
      setSalvo(true);
      setTimeout(() => setSalvo(false), 2000);
    }
    setSalvando(false);
  }

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando configurações...</div>;

  return (
    <div>
      <div className="section-header">
        <h2 className="section-title">Configurações</h2>
        <div className="section-line" />
      </div>

      {erro && (
        <div style={{ background:'#fee2e2', border:'1px solid #dc2626', borderRadius:8, padding:'12px 16px', marginBottom:16, fontSize:13, color:'#dc2626' }}>
          {erro}
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
        <div className="card" style={{ padding:24 }}>
          <div style={{ fontWeight:700, fontSize:15, color:'var(--text-primary)', marginBottom:20 }}>Dados da empresa</div>
          {[
            { label:'Nome da empresa', key:'nome' },
            { label:'Slogan', key:'slogan' },
            { label:'E-mail', key:'email' },
            { label:'WhatsApp', key:'whatsapp' },
          ].map(f => (
            <div key={f.key} style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:600, color:'var(--gray-400)', marginBottom:6, textTransform:'uppercase' }}>{f.label}</label>
              <input value={empresa[f.key] || ''} onChange={e => setEmpresa({...empresa, [f.key]: e.target.value})}
                style={{ width:'100%', padding:'10px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:14, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
            </div>
          ))}
        </div>

        <div className="card" style={{ padding:24 }}>
          <div style={{ fontWeight:700, fontSize:15, color:'var(--text-primary)', marginBottom:20 }}>Notificações</div>
          {[
            { label:'Novo lead chegou',     key:'novoLead' },
            { label:'Follow-up atrasado',   key:'followup' },
            { label:'No-show registrado',   key:'noshow' },
            { label:'Meta atingida',        key:'meta' },
          ].map(f => (
            <div key={f.key} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 0', borderBottom:'1px solid var(--border)' }}>
              <span style={{ fontSize:14, color:'var(--text-primary)' }}>{f.label}</span>
              <div onClick={() => setNotif({...notif, [f.key]: !notif[f.key]})}
                style={{ width:44, height:24, borderRadius:20, background: notif[f.key] ? 'var(--purple)' : 'var(--border)', cursor:'pointer', position:'relative', transition:'background 0.2s' }}>
                <div style={{ width:18, height:18, borderRadius:'50%', background:'white', position:'absolute', top:3, left: notif[f.key] ? 23 : 3, transition:'left 0.2s' }} />
              </div>
            </div>
          ))}

          <div style={{ marginTop:20, padding:14, background:'var(--bg-secondary)', borderRadius:8, fontSize:12, color:'var(--gray-400)', lineHeight:1.5 }}>
            As configurações são salvas no banco de dados e refletem para toda a equipe.
          </div>
        </div>
      </div>

      <div style={{ marginTop:24, display:'flex', justifyContent:'flex-end', gap:10 }}>
        <button onClick={carregarConfigs}
          style={{ background:'transparent', border:'1px solid var(--border)', padding:'12px 20px', borderRadius:6, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>
          Descartar
        </button>
        <button onClick={salvar} disabled={salvando}
          style={{ background: salvo ? '#16a34a' : 'var(--purple)', color:'white', border:'none', padding:'12px 32px', borderRadius:6, fontWeight:600, cursor:'pointer', fontSize:14, transition:'background 0.2s', opacity: salvando ? 0.7 : 1 }}>
          {salvo ? 'Salvo!' : salvando ? 'Salvando...' : 'Salvar configurações'}
        </button>
      </div>
    </div>
  );
}
